<div class="kendo-textbox" [formGroup]="parentForm">
  <kendo-formfield>
    <kendo-floatinglabel text="{{ inputText }}">
      <kendo-textbox
        #passtextbox
        class="k-floating-label-container k-empty"
        [formControlName]="formControlName"
        type="inputType"
      >
      </kendo-textbox>
    </kendo-floatinglabel>
  </kendo-formfield>
</div>
